var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03519 4.45588C7.49895 4.45588 7.875 4.07983 7.875 3.61607C7.875 3.15179 7.49895 2.77679 7.03519 2.77679C6.57143 2.77679 6.19538 3.15179 6.19538 3.61607C6.19538 4.07983 6.57143 4.45588 7.03519 4.45588Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60557 5.01628H5.92542V5.57616H6.4853V10.3361H5.92542V10.896H8.16544V10.3361H7.60557V5.01628Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13393 0 0 3.13445 0 7C0 10.8666 3.13445 14 7 14C10.8655 14 14 10.8666 14 7C14 3.13393 10.8655 0 7 0ZM7 13.4401C3.44905 13.4401 0.559874 10.5509 0.559874 7C0.559874 3.44905 3.44853 0.559874 7 0.559874C10.5509 0.559874 13.4401 3.44905 13.4401 7C13.4401 10.5509 10.5515 13.4401 7 13.4401Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8c76aa2b22f507472fcad3a9f8f246d6.svg";
export { ForwardRef as ReactComponent };